import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl, headersDefault } from ".";
import { fetchJsonRead } from "../../services/readRequest";

export const fetchAppPermissions = createAsyncThunk(
  "permissions/fetchAppPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchJsonRead(
        `${baseUrl}/api/app/permissions/list`,
        { headers: headersDefault() },
      );
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Errore nel caricamento dei permessi",
      );
    }
  },
  {
    // Dedupe concurrent calls: multiple consumers (AppStateManager
    // boot + useAppPermission self-heal + Paywall purchase) can all
    // fire on the same tick; skip if a request is already in flight.
    condition: (_, { getState }) => !getState().permissions?.isLoading,
  },
);
